export const FETCH_PRICE_PACKAGES_EDITOR = 'FETCH_PRICE_PACKAGES_EDITOR';
export type FETCH_PRICE_PACKAGES_EDITOR = typeof FETCH_PRICE_PACKAGES_EDITOR;

export interface FetchPricePackagesEditorAction {
    type: FETCH_PRICE_PACKAGES_EDITOR;
}

export function fetchPricePackagesEditor(): FetchPricePackagesEditorAction {
    return {
        type: FETCH_PRICE_PACKAGES_EDITOR
    };
}

export type PricePackagesEditorAction = FetchPricePackagesEditorAction;
